import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=9474370a&scoped=true&"
import script from "./addDetail.vue?vue&type=script&lang=js&"
export * from "./addDetail.vue?vue&type=script&lang=js&"
import style0 from "./addDetail.vue?vue&type=style&index=0&id=9474370a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9474370a",
  null
  
)

export default component.exports